import store from '../store'
import Helpers from '@/lib/helpers'

const basicGuard = async function (to, from, next) {
    if (to.meta.guard) {
        if (to.meta.guard.permission) {
            // an array means ANY of these, for a screen two roles reach by
            // different doors. can() is a plain indexOf on a string, so an
            // array would otherwise never match and the route would deny
            // everyone.
            const perms = to.meta.guard.permission
            const allowed = Array.isArray(perms)
                ? perms.some(p => Helpers.can(p))
                : Helpers.can(perms)

            if (!allowed) {
                next({name: 'catchall', params: {error: 'Permission Denied', help: 'Requires ' + to.meta.guard.permission}})
                return
            }
        }

        if (to.meta.guard.type) {
            if ((store.state.record.type !== to.meta.guard.type) || (!store.state.record.active) || (to.params.id !== store.state.record.active.id)) {
                try {
                    if (to.params.id == 0) {
                        await store.commit('record_start', {type: to.meta.guard.type, record: null})
                    } else {
                        await store.dispatch('record_load', {
                            type: to.meta.guard.type,
                            options: {quiet: true},
                            url: {
                                href: to.meta.guard.endpoint + to.params.id + (to.meta.guard.append || ''),
                                method: 'get'
                            }
                        })
                    }
                    next()
                } catch (e) {
                    next({name: 'catchall', params: {error: 'Record not found'}})
                }
            } else if (to.params.id === null) {
                next({name: 'catchall', params: {error: 'Record not found'}})
            } else {
                next()
            }
        } else {
            next()
        }
    } else {
        next()
    }
}

export default basicGuard